import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismSelectInput } from '@mylighthouse/prism-ember';
import type { Room } from 'lumen/components/settings/central-mapping/roomtype-mapping';

// @ts-expect-error: Incorrect type
function capitalizeFirstLetter(sentence): string {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
}

interface SettingsCentralMappingRoomtypeMappingCellRoomtypeSelectSignature {
  Args: {
    onSelectRoom: unknown;
    room: unknown;
    sortedSelections: unknown;
  };
}

export default class SettingsCentralMappingRoomtypeMappingCellRoomtypeSelect extends Component<SettingsCentralMappingRoomtypeMappingCellRoomtypeSelectSignature> {
  get options(): { label: string; room: Room }[] {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return this.args.sortedSelections.map((room) => ({
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      label: room.proper_name,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      room,
    }));
  }

  get value(): { label: string } {
    return {
      // @ts-expect-error: Incorrect type

      label: capitalizeFirstLetter(this.args.room.name),
    };
  }

  @action
  // @ts-expect-error: Incorrect type
  handleChange(option): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    this.args.onSelectRoom(option.room, this.args.room);
  }

  <template>
    <PrismSelectInput
      {{! @glint-expect-error: Incorrect type }}
      @dataEventId="hotel-roomtype-mapping-toggle-dropdown"
      @onChange={{this.handleChange}}
      @options={{this.options}}
      @unsafe_openOnClick={{true}}
      @value={{this.value}}
    />
  </template>
}
